import React from 'react';
import { Table, Select, InputNumber, Input, Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

interface POItem {
    id?: number;
    internal_sku: number;
    sku_code?: string;
    sku_name?: string;
    quantity: number;
    unit_price: number;
    tax_rate: number;
    remark?: string;
    total_price?: number;
}

interface POItemsTableProps {
    items: POItem[];
    skus: any[];
    currentStatus: string;
    onUpdateItem: (index: number, field: keyof POItem, value: any) => void;
    onRemoveItem: (index: number) => void;
    totalAmount: number;
}

const { Option } = Select;

export const POItemsTable: React.FC<POItemsTableProps> = ({
    items, skus, currentStatus, onUpdateItem, onRemoveItem, totalAmount
}) => {
    const columns = [
        {
            title: '产品 SKU', dataIndex: 'internal_sku', key: 'internal_sku', width: 300,
            render: (val: number, _: any, index: number) => (
                <Select
                    showSearch style={{ width: '100%' }} placeholder="选择 SKU"
                    optionFilterProp="children" value={val || undefined}
                    onChange={(v) => onUpdateItem(index, 'internal_sku', v)}
                    disabled={currentStatus === 'received'}
                >
                    {skus.map(s => <Option key={s.id} value={s.id}>{s.sku_code} - {s.name}</Option>)}
                </Select>
            ),
        },
        {
            title: '单价', dataIndex: 'unit_price', key: 'unit_price', width: 120,
            render: (val: number, _: any, index: number) => (
                <InputNumber min={0} precision={2} value={val} onChange={(v) => onUpdateItem(index, 'unit_price', v)} disabled={currentStatus === 'received'} />
            ),
        },
        {
            title: '数量', dataIndex: 'quantity', key: 'quantity', width: 120,
            render: (val: number, _: any, index: number) => (
                <InputNumber min={1} value={val} onChange={(v) => onUpdateItem(index, 'quantity', v)} disabled={currentStatus === 'received'} />
            ),
        },
        {
            title: '小计', key: 'subtotal', width: 120,
            render: (_: any, record: POItem) => `¥${(record.quantity * record.unit_price).toFixed(2)}`,
        },
        {
            title: '备注', dataIndex: 'remark', key: 'remark',
            render: (val: string, _: any, index: number) => (
                <Input value={val} onChange={(e) => onUpdateItem(index, 'remark', e.target.value)} disabled={currentStatus === 'received'} />
            ),
        },
        {
            title: '操作', key: 'action', width: 80,
            render: (_: any, __: any, index: number) => (
                <Button type="link" danger icon={<DeleteOutlined />} onClick={() => onRemoveItem(index)} disabled={currentStatus === 'received'} />
            ),
        },
    ];

    return (
        <Table
            dataSource={items}
            columns={columns}
            rowKey={(record, index) => record.id || index!}
            pagination={false}
            footer={() => (
                <div style={{ textAlign: 'right', fontSize: '16px', fontWeight: 'bold' }}>
                    总计金额: ¥{totalAmount.toFixed(2)}
                </div>
            )}
        />
    );
};
